import React from "react";
import SelectDays from "./inputs/select-days";
import SvgIcon from "../parts/SvgIcon";

const EditAccountability = ({
  state,
  setState,
  id,
  setDays,
  removeItem,
  adding,
}) => {
  const weekDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const [checked, setChecked] = React.useState(false);

  const handleChange = (e) => {
    setState(
      state.map((item, i) => {
        return i === id
          ? {
              ...item,
              [e.target.name]: e.target.value,
            }
          : item;
      })
    );
  };
  const isntEverydayChecked = () =>
    Object.values(state[id].days).includes(false);
  const handleCheckAll = () => {
    const obj = {};
    weekDays.forEach((day) => (obj[day] = isntEverydayChecked()));
    setState(
      state.map((item, i) => {
        return i === id
          ? {
              ...item,
              days: obj,
            }
          : item;
      })
    );
    setChecked(!checked);
  };
  React.useEffect(() => {
    if (isntEverydayChecked()) setChecked(false);
    else setChecked(true);
  }, [state[id].days]);

  return (
    <>
      <div className="add-new-accountability">
        <h4>Add New</h4>
      </div>
      <div className={`add-accountability-container${adding ? " adding" : ""}`}>
        <div className="left-add-acc">
          <textarea
            name="title"
            value={state[id].title}
            placeholder="Title"
            onChange={handleChange}
          ></textarea>
          <textarea
            name="description"
            value={state[id].description}
            placeholder="Enter description here..."
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="right-add-acc">
          <div className="add-main-right">
            <p>Select the days to schedule this habit</p>
            <SelectDays days={state[id].days} setDays={setDays} />
            <div className="acc-select-everyday">
              <SvgIcon
                alt="check"
                src={
                  checked
                    ? "/img/new-icons/tick-circle.svg"
                    : "/img/new-icons/vuesax-linear-tick-circle.svg"
                }
                onClick={handleCheckAll}
                noFilterOnLight={checked}
              />
              <p className="p6">Everyday</p>
            </div>
          </div>
          <div className="accountability-btns mobile-hidden">
            <button
              data-button-type="secondary"
              data-icon-only
              sz="medium"
              onClick={removeItem}
              type="button"
            >
              <img src="/img/new-icons/red-trash.svg" alt="delete" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditAccountability;
